export var Templates;
(function (Templates) {
    Templates["BLOG"] = "BLOG";
    Templates["ARTICLE_DETAIL"] = "ARTICLE_DETAIL";
    Templates["ARTICLES"] = "ARTICLES";
})(Templates || (Templates = {}));
